export const formacoes = [
  {
    id: "macd-meeting",
    eyebrow: "Metodologia autoral",
    title: "MACD Meeting",
    description:
      "Treinamento presencial de 8 horas, realizado em um único dia, para apresentar a metodologia MACD e ampliar a visão do profissional da beleza sobre marketing, autoconhecimento, ciência do cabelo e desenvolvimento comportamental.",
    duration: "Presencial · 8h · Um dia",
    whatsappMessage:
      "Olá! Gostaria de conhecer o MACD Meeting da Oasys Academy.",
  },
  {
    id: "auxiliar-smart",
    eyebrow: "Formação presencial",
    title: "Auxiliar @Smart",
    description:
      "Uma nova visão do espaço de beleza para auxiliares. Formação presencial com bolsa gratuita, 64 horas de treinamento, estágio de 30 dias no Oasys Hair e possibilidade de indicação para outros salões parceiros.",
    duration: "Bolsa gratuita · 64h · Estágio de 30 dias",
    whatsappMessage:
      "Olá! Tenho interesse na formação Auxiliar @Smart da Oasys Academy.",
  },
  {
    id: "pensando-reverso",
    eyebrow: "Mentalidade e estratégia",
    title: "Pensando Reverso",
    description:
      "Treinamento online para profissionais que precisam transformar a forma de pensar antes de transformar o salão. São 3 encontros ao vivo, com 1 hora cada, durante uma semana.",
    duration: "Online ao vivo · 3 encontros · Turma com 20 pessoas",
    note: "Os encontros acontecem terça, quarta e quinta-feira.",
    whatsappMessage:
      "Olá! Quero conhecer o Pensando Reverso da Oasys Academy.",
  },
  {
    id: "do-corte-ao-lucro-1",
    eyebrow: "Consciência de salão",
    title: "Do Corte ao Lucro 1",
    description:
      "Treinamento para profissionais da beleza que precisam aprender a pensar o salão além do corte. Uma formação sobre consciência de salão, equipe, relacionamento, autoconhecimento, administração e construção de uma visão mais estratégica da própria carreira.",
    duration: "Online ao vivo · 4 semanas · 24h",
    whatsappMessage:
      "Olá! Quero saber mais sobre o Do Corte ao Lucro 1 da Oasys Academy.",
  },
  {
    id: "do-corte-ao-lucro-2",
    eyebrow: "Inteligência de crescimento",
    title: "do Corte ao Lucro 2",
    description:
      "A nova fase do treinamento. Uma formação para profissionais da beleza que querem transformar atendimento em inteligência de crescimento, aprendendo a ler dados, agenda, frequência, retorno, ausência, ticket e comportamento do cliente.",
    duration:
      "Online ao vivo · 4 semanas · 24h · Turma com 12 pessoas",
    note: "As aulas acontecem de terça a quinta-feira, das 8h às 10h da manhã.",
    whatsappMessage:
      "Olá! Quero conhecer o do Corte ao Lucro 2 da Oasys Academy.",
    featured: true,
  },
];
